import React from 'react';
import UserReportStore from '../flux/reports/UserReportStore';
import UserReportStoreActions from '../flux/reports/UserReportStoreActions';
import collectionTypeToParentType from '../utils/collectionTypeToParentType';

export default function withUserReportData(WrapperComponent) {
  return class WithUserReportData extends React.Component {
    static defaultProps = {
      match: undefined, // Required
    };

    state = {
      isLoading: false,
      themes: [],
      themesCompleted: '-',
      themesCount: '-',
    };

    subscriptions = [];

    componentDidMount() {
      this.fetchUserReport();

      this.subscriptions.push(UserReportStore.addListener(() => {
        const themes = UserReportStore.getState();

        this.setState({
          isLoading: false,
          themes,
          themesCompleted: `${themes.filter(theme => theme.status === 'theme_completed').length}`,
          themesCount: `${themes.length}`,
        });
      }));
    }

    // static getDerivedStateFromProps(nextProps, prevState) {
    //   if (
    //     nextProps.isLoading !== prevState.isLoading ||
    //     nextProps.themes !== prevState.themes
    //   ) {
    //     return nextProps;
    //   }
    //
    //   return null;
    // }

    componentDidUpdate(prevProps) {
      if (
        prevProps.match.params.collectionType !== this.props.match.params.collectionType ||
        prevProps.match.params.parentId !== this.props.match.params.parentId ||
        prevProps.match.params.store !== this.props.match.params.store ||
        prevProps.match.params.username !== this.props.match.params.username
      ) {
        this.fetchUserReport();
      }
    }

    componentWillUnmount() {
      this.subscriptions.forEach(subscription => subscription.remove());
    }

    fetchUserReport() {
      const { collectionType, parentId, store, username } = this.props.match.params;

      // We don't want to perform a fetch without all the required parameters in
      // the URL.
      if ([collectionType, parentId, store, username].some(value => value === undefined)) {
        return;
      }

      setTimeout(() => (
        UserReportStoreActions.fetch(
          collectionTypeToParentType(collectionType),
          parentId,
          store,
          username,
        )
      ), 0);

      this.setState({
        isLoading: true,
        themes: [],
        themesCompleted: '-',
        themesCount: '-',
      });
    }

    render() {
      return (
        <WrapperComponent {...this.state} {...this.props} />
      )
    }
  }
}
